import type { SugarmateError } from "@tandemdiabetes/sugarmate-api-react-client"
import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { useMemo } from "react"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  code?: SugarmateError["code"];
}

const polyglotPrefix = "toasts.sign_in_error."

export function SignInErrorToast(props: Props) {
  const {
    id, code,
  } = props
  const polyglot = usePolyglot()

  const body = useMemo(
    () => {
      switch (code) {
        case 1028: // invalid data center
          return polyglot.t(`${polyglotPrefix}invalid_data_center_body`)
        default:
          return polyglot.t("error_messaging.generic_error")
      }
    },
    [
      code,
      polyglot,
    ],
  )

  return (
    <Toast
      stylePreset="error"
      body={body}
      id={id}
      // the default toastMs is 2300, this adds two seconds to show the long
      // invalid_data_center_body message
      toastMs={code === 1028 ? 4300 : undefined}
    />
  )
}
